import { render, staticRenderFns } from "./ListVotes.vue?vue&type=template&id=70993834&scoped=true"
import script from "./ListVotes.vue?vue&type=script&lang=js"
export * from "./ListVotes.vue?vue&type=script&lang=js"
import style0 from "./ListVotes.vue?vue&type=style&index=0&id=70993834&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70993834",
  null
  
)

export default component.exports